<template>
  <div class="arc-sec">
    <div class="arc-toolbar"><div class="spacer" /><button class="btn primary" type="button" @click="openNew">+ {{ $t('ARC_MGMT.ADD') }}</button></div>
    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <div v-else class="grid">
      <div v-for="b in items" :key="b.id" class="badge" :class="{ locked: !b.conquistada }">
        <div class="medal" :class="b.pilar">{{ b.sigla }}</div>
        <div class="info">
          <b>{{ b.nome }}</b>
          <span v-if="b.conquistada" class="ok">{{ $t('ARC_MGMT.BADGES.EARNED') }} {{ (b.conquistada_em || '').slice(0,10) }}</span>
          <span v-else class="muted">{{ b.descricao }}</span>
        </div>
        <div class="acts">
          <button v-if="!b.conquistada" class="link" type="button" @click="grant(b)">{{ $t('ARC_MGMT.BADGES.GRANT') }}</button>
          <button v-else class="link danger" type="button" @click="revoke(b)">{{ $t('ARC_MGMT.BADGES.REVOKE') }}</button>
          <button class="link" type="button" @click="openEdit(b)">{{ $t('ARC_MGMT.EDIT') }}</button>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="arc-modal-bg" @click.self="showModal = false">
      <div class="arc-modal">
        <h3>{{ editing.id ? $t('ARC_MGMT.EDIT') : $t('ARC_MGMT.ADD') }}</h3>
        <div class="row">
          <label>{{ $t('ARC_MGMT.BADGES.NAME') }}<input v-model="editing.nome" type="text" /></label>
          <label>{{ $t('ARC_MGMT.BADGES.SIGLA') }}<input v-model="editing.sigla" type="text" maxlength="3" /></label>
          <label>{{ $t('ARC_MGMT.PILLAR') }}<select v-model="editing.pilar"><option>geral</option><option>A</option><option>R</option><option>C</option></select></label>
        </div>
        <label>{{ $t('ARC_MGMT.BADGES.DESC') }}<textarea v-model="editing.descricao" rows="2" /></label>
        <div class="modal-actions">
          <button class="btn danger-ghost" v-if="editing.id" type="button" @click="remove(editing)">{{ $t('ARC_MGMT.DELETE') }}</button>
          <div class="spacer" />
          <button class="btn" type="button" @click="showModal = false">{{ $t('ARC_MGMT.CANCEL') }}</button>
          <button class="btn primary" type="button" @click="save">{{ $t('ARC_MGMT.SAVE') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArcAPI from 'dashboard/api/arc';
export default {
  props: { journey: { type: Object, default: () => ({}) } },
  data() { return { items: [], loading: true, showModal: false, editing: {} }; },
  mounted() { this.load(); },
  methods: {
    async load() { this.loading = true; try { const { data } = await ArcAPI.badges(); this.items = data.payload || []; } finally { this.loading = false; } },
    openNew() { this.editing = { pilar: 'geral', regra: { tipo: 'manual' } }; this.showModal = true; },
    openEdit(b) { this.editing = { ...b }; this.showModal = true; },
    async save() {
      const p = (({ nome, descricao, sigla, pilar }) => ({ nome, descricao, sigla, pilar }))(this.editing);
      if (this.editing.id) await ArcAPI.updateBadge(this.editing.id, p); else await ArcAPI.createBadge({ ...p, regra: { tipo: 'manual' } });
      this.showModal = false; this.load();
    },
    async grant(b) { await ArcAPI.grantBadge(b.id); this.load(); this.$emit('refresh'); },
    async revoke(b) { const motivo = window.prompt(this.$t('ARC_MGMT.BADGES.REVOKE_REASON')); if (!motivo) return; await ArcAPI.revokeBadge(b.id, motivo); this.load(); },
    async remove(b) { if (!window.confirm(this.$t('ARC_MGMT.DELETE') + '?')) return; await ArcAPI.deleteBadge(b.id); this.showModal = false; this.load(); },
  },
};
</script>
<style lang="scss" scoped>
.arc-toolbar { display: flex; margin-bottom: var(--space-normal); } .spacer { flex: 1; } .muted { color: var(--s-500); }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: var(--space-normal); }
.badge { display: flex; align-items: center; gap: var(--space-normal); border: 1px solid var(--s-100); border-radius: var(--border-radius-normal); padding: var(--space-normal); background: var(--white); &.locked { opacity: .7; } }
.medal { width: 2.8rem; height: 2.8rem; border-radius: var(--border-radius-rounded); display: grid; place-items: center; font-weight: var(--font-weight-bold); color: var(--white); background: var(--s-400);
  &.A { background: #1E88E5; } &.R { background: #1F9D63; } &.C { background: #7B61FF; } }
.badge.locked .medal { background: var(--s-200); color: var(--s-500); }
.info { flex: 1; display: flex; flex-direction: column; gap: var(--space-micro); font-size: var(--font-size-small); color: var(--s-800); }
.info .ok { color: var(--g-600); font-size: var(--font-size-mini); } .info .muted { font-size: var(--font-size-mini); }
.acts { display: flex; flex-direction: column; gap: var(--space-micro); }
.link { border: 0; background: none; color: var(--w-600); font-size: var(--font-size-mini); cursor: pointer; &.danger { color: var(--r-500); } }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer; &.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); } &.danger-ghost { border-color: var(--r-200); color: var(--r-500); } }
.arc-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: grid; place-items: center; z-index: 9999; }
.arc-modal { background: var(--white); border-radius: var(--border-radius-large); padding: var(--space-large); width: 32rem; max-width: 92vw;
  h3 { margin: 0 0 var(--space-normal); color: var(--s-900); } label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); margin-bottom: var(--space-small); }
  input, textarea, select { border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: var(--space-smaller) var(--space-small); background: var(--white); color: var(--s-800); } .row { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: var(--space-small); } }
.modal-actions { display: flex; align-items: center; gap: var(--space-small); margin-top: var(--space-normal); }
</style>
